type State = {
  authorized: boolean,
  authStarted: boolean,
  email: string,
  first_name: string,
  last_name: string,
}

const initialState: State = {
  authorized: localStorage.getItem('authorized') === 'true',
  authStarted: false,
  email: localStorage.getItem('email') || '',
  first_name: localStorage.getItem('first_name') || '',
  last_name: localStorage.getItem('last_name') || ''
}

export function auth(state: State = initialState, action: Action): State {
  switch (action.type) {
    case 'SET_AUTH_STARTED':
      return { ...state, authStarted: action.value };
    case 'LOGIN':
      return { ...state, authorized: true, email: action.email, first_name: action.first_name, last_name: action.last_name };
    case 'LOGOUT':
      return { ...state, authorized: false, first_name: '', last_name: '', email: '' };
    default:
      return state;
  }
}
